package com.eladfinish.bible.contest.di.haptics

import com.eladfinish.bible.contest.platform.haptics.HapticFeedback
import com.eladfinish.bible.contest.platform.haptics.WebHapticFeedback
import org.koin.core.module.Module
import org.koin.dsl.module

internal actual val hapticsPlatformModule: Module = module {
    single<HapticFeedback> { WebHapticFeedback() }
}
